import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { Download } from "@vitalsource/vstui-icons";
import { cloud } from "@vitalsource/vstui/colors";
import {
  StyledLikeAccordion,
  StyledLikeAccordionButton
} from "../../../styles";
import {
  selectors as ancillarySelectors,
  actions as ancillaryActions
} from "../../../../../../redux/ancillaries";
import {
  selectors as bridgeSelectors,
  actions as bridgeActions
} from "../../../../../../redux/bridge";
import Spinner from "../../../../../components/spinner";
import { styledMedia } from "../../../../../components/mediaquery/breakpoints";
import { OffScreenStyles } from "../../../../../components/mixins";
import { t } from "../../../../../core/translate";
import { nameFromUrl } from "../../../../../../../fraction/utils/string-utils";

const Wrapper = styled.div`
  background-color: ${cloud.getShade(2)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;
const OuterContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  -wekbit-overflow-scrolling: touch;
  padding: 33px 26px 233px;

  ${styledMedia.medium`
    padding: 19px 16px;
  `}
`;

const DownloadIcon = styled(Download)`
  height: 20px;
  width: 15px;
`;

const FileSize = styled.span`
  font-weight: 300;
  font-size: 1.6rem;
  color: ${cloud.getShade(7)};
  margin-left: auto;
  margin-right: 10px;
`;

const FileType = styled.span`
  font-weight: 400;
  font-size: 1.6rem;
  color: ${cloud.getShade(7)};
  margin-right: 10px;
  text-transform: capitalize;
`;

const Icon = styled.div`
  min-height: 30px;
`;

const ResourceText = styled.div`
  width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PanelHeadingTag = styled.h3`
  ${OffScreenStyles};
`;

class BookResourcesContainer extends React.Component {
  componentDidMount() {
    this.props.fetchAncillaries(this.props.isbn);
  }
  renderResources() {
    const {
      source,
      libraryAncillaries,
      isLibraryFetching,
      theme,
      isBridgeFetching,
      bridgeAncillaries
    } = this.props;
    if (isLibraryFetching || isBridgeFetching) {
      return <Spinner />;
    }

    const ancillaries =
      source === "bridge" ? bridgeAncillaries : libraryAncillaries;
    let resourcesList = ancillaries.map((resource, index) => {
      const hasAccessCode = resource.type === "accesscode";
      let { title, href } = resource;
      if (!title && href) {
        title = nameFromUrl(href);
      } else {
        title = decodeURIComponent(resource.title).replace("/", "");
      }
      return (
        <div key={index}>
          <PanelHeadingTag>
            {t("filter.resources", "Resources")}
          </PanelHeadingTag>
          {!hasAccessCode && (
            <StyledLikeAccordion>
              <StyledLikeAccordionButton href={resource.href} target="_blank">
                <ResourceText>{title}</ResourceText>
                <FileSize>
                  {parseInt(resource.size) > 0 ? resource.size : null}
                </FileSize>
                <FileType>{resource.type || null}</FileType>
                <DownloadIcon color={theme.color.primary.getShade(7)} />
                <Icon />
              </StyledLikeAccordionButton>
            </StyledLikeAccordion>
          )}
        </div>
      );
    });

    return resourcesList;
  }

  render() {
    return (
      <Wrapper>
        <OuterContainer>{this.renderResources()}</OuterContainer>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, props) => ({
  libraryAncillaries:
    props.source === "library"
      ? ancillarySelectors.getAncillariesForVbid(state, props.isbn)
      : null,
  isLibraryFetching:
    props.source === "library"
      ? ancillarySelectors.isAncillariesFetching(state, props.isbn)
      : null,
  bridgeAncillaries:
    props.source === "bridge"
      ? bridgeSelectors.getAncillariesForVbid(state, props.isbn)
      : null,
  isBridgeFetching:
    props.source === "bridge"
      ? bridgeSelectors.isAncillariesFetching(state, props.isbn)
      : null
});

const mapDispatchToProps = (dispatch, props) => ({
  fetchAncillaries: () => {
    if (props.source === "library") {
      dispatch(ancillaryActions.fetchAncillaries(props.isbn));
    } else {
      dispatch(bridgeActions.fetchAncillaries(props.isbn));
    }
  }
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(BookResourcesContainer)
);
